var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    x1: -64.72,
    y1: 111.62,
    x2: -63.93,
    y2: 112.53,
    gradientTransform: "matrix(46, 0, 0, -44.24, 2984, 4982.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbcc14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e52085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b1eb4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_2",
    "data-name": "Uni\\xF3n 2",
    className: "cls-1",
    d: "M15.14,48A13.14,13.14,0,0,1,2,34.86V15.14A13.14,13.14,0,0,1,15.14,2H34.86A13.14,13.14,0,0,1,48,15.14V34.86A13.14,13.14,0,0,1,34.86,48Zm-9-32.86V34.86a9,9,0,0,0,9,9H34.86a9,9,0,0,0,9-9V15.14a9,9,0,0,0-9-9H15.14a9,9,0,0,0-9,9Zm7,9.86A11.91,11.91,0,1,1,25,36.91,11.91,11.91,0,0,1,13.09,25Zm4.11,0A7.8,7.8,0,1,0,25,17.2,7.81,7.81,0,0,0,17.2,25ZM34.36,12.68a3,3,0,1,1,2.84,3,3,3,0,0,1-2.84-3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.b642be8fe02c86d252fc6ae40c460b4c.svg";
export { ForwardRef as ReactComponent };